<template>
    <div>
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
            id="popUpUsersLink"
        >
            <div>
                <span id="display-span-orders">
                    <vs-icon @click="$emit('backToOrerSummarry')" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 16px; width: 400px;">Vincular usuário ao serviço</p>
                    <div class="flex-end-align">
                        <vs-icon @click="$emit('isActiveFalse')" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <vs-table
                class="mr-2"
                noDataText="Nenhum resultado encontrado"
                v-model="selected"
                :data="usersList"
                max-items="4"
                id="users-link-table"
                search
                pagination
            >
                <template slot="thead">
                    <vs-th sort-key="name">Nome</vs-th>
                    <vs-th sort-key="email">E-mail</vs-th>
                    <vs-th sort-key="username">Usuário</vs-th>
                    <vs-th sort-key="role">Permissão</vs-th>
                    <vs-th sort-key="status" v-if="isAdminUser">Status</vs-th>
                </template>
                
                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="users-list-link">
                            <vs-td>
                            <p>{{ tr.name }}</p>
                            </vs-td>

                            <vs-td>
                            <p>{{ tr.email }}</p>
                            </vs-td>

                            <vs-td>
                                <p>{{ tr.username }}</p>
                            </vs-td>

                            <vs-td>
                            <p>
                                {{ tr.role ? tr.role.display_name : '' }}
                            </p>
                            </vs-td>

                            <vs-td>
                            <vs-chip :color="getConnectionStatusColor(tr.isConnected)">
                                {{ getConnectionStatusName(tr.isConnected) | title }}
                            </vs-chip>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <vs-button 
              @click="setUser" 
              class="btn-drop px-3 mr-6 mt-3" 
              type="filled" 
              icon="keyboard_arrow_right" 
              icon-after style="float: right !important; border-radius: 12px;"
              :disabled="selected === null ? true : false "
            >
            
                Continuar
            </vs-button>
        </vs-popup>
    </div>
</template>

<script>

    import userRequest from "@/http/requests/user/index";

    export default {
        name: 'LinkUserPopUp',
        data() {
            return {
                usersList: [],
                selected: null
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
        },
        methods: {
            async fetchUsers() {
                await userRequest.fetch()
                .then((users) => {
                    this.usersList = users.data.data.users;
                })
            },
            getConnectionStatusName(activated) {
                if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
                    return 'Online'
                }
                return 'Offline'
            },
            getConnectionStatusColor(activated) {
                if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
                    return 'success'
                }
                return 'danger'
            },
            setUser() {
                this.$emit('changeUser', this.selected);
                this.selected = null;
            }
        },
        computed: {
            isAdminUser() {
            let userInfo = JSON.parse(localStorage.getItem("userInfo"))
                if (userInfo && userInfo.role) {
                    if (userInfo.role.name === 'administrador') {
                    return true
                    }
                }
            return false
            },
        },
        async mounted() {
            await this.fetchUsers();
        },
        watch : {
            isActive(val) {
                if(val) {
                    this.selected = null;
                    this.fetchUsers();
                }
            }
        }
    }
</script>

<style lang="scss">
    #popUpUsersLink div.vs-popup {
        .vs-popup--content {
        padding: 15px;
        margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 830px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;
        }
        input.vs-inputx.vs-input--input.normal {
            border-radius: 14px !important;
            width: 300px;
        }
    
        #users-link-table {
            padding: 4px;
            .vs-con-tbody.vs-table--tbody {
                background-color: transparent !important;
                border: 0 !important; 
            }
            table.vs-table.vs-table--tbody-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;
            }
            .vs-table-text {
                text-align: center;
            }
            tbody {
                tr.is-selected {
                    border-radius: 18px !important; 
                }
                tr {

                    td {
                        padding: 0px;
                        border-style: solid; 
                        border-color: #b6bebd6e !important;
                        height: 4em;
                    }
                    td.td.vs-table--td {
                        text-align: center;
                    }
                    td:first-of-type {
                        border-top-left-radius: 18px !important; 
                        border-bottom-left-radius: 18px !important; 
                        border-width: 1px 0px 1px 1px;
                    }
                    td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4) {
                        border-width: 1px 0px 1px 0px; 
                    }
                    td:last-of-type {
                        border-width: 1px 1px 1px 0px;
                        border-top-right-radius: 18px !important;
                        border-bottom-right-radius: 18px !important;
                        padding-right: 10px;
                    }
                }
            }
        }
    }
</style>